import { Box, Grid, useTheme } from '@mui/material';
import InstallationTree from './InstallationTree';
import InstallationsContextProvider from 'src/contexts/InstallationsContextProvider';

function TreeView() {
  const theme = useTheme();

  return (
    <InstallationsContextProvider>
      <Grid item xs={12}>
        <Box p={4}>
          <InstallationTree />
        </Box>
      </Grid>
    </InstallationsContextProvider>
  );
}

export default TreeView;
